import { API_ENDPOINT } from './config';

export const urlsCalendar = {
  // Calendar/events (academic calendar)
  calendar: `${API_ENDPOINT}/events`,
  calendarImport: `${API_ENDPOINT}/events/import`,
  calendarMonth: (date) => `${API_ENDPOINT}/events?month=${date.toISOString()}`,
  calendarYear: (year) =>
    year ? `${API_ENDPOINT}/events?year=${year}` : `${API_ENDPOINT}/events`,
};
export const routesCalendar = {
  cmsCalendar: '/cms/events',
  cmsCalendarCreate: '/cms/event/create',
  cmsCalendarEdit: '/cms/event/edit',
  calendar: '/akademicky-kalendar',
};
